import { render, staticRenderFns } from "./itemtype.vue?vue&type=template&id=7e9d7784&scoped=true&"
import script from "./itemtype.vue?vue&type=script&lang=js&"
export * from "./itemtype.vue?vue&type=script&lang=js&"
import style0 from "./itemtype.vue?vue&type=style&index=0&id=7e9d7784&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e9d7784",
  null
  
)

export default component.exports